import { useCodatAuth } from "@codat/client-cookie-manager";
import {
  makeAxiosInterceptorsInstance,
  makeFetchInstance,
} from "api/interceptors";
import { PublicApiClient } from "api/public-service";
import React, { createContext, useContext } from "react";

import config from "config";

export const PublicApiServiceContext = createContext<PublicApiClient>(
  {} as PublicApiClient
);

export const PublicApiServiceProvider = ({
  children,
}: React.PropsWithChildren) => {
  const auth = useCodatAuth();
  const axiosInstance = makeAxiosInterceptorsInstance(
    auth,
    config.PUBLIC_API_URL
  );
  const fetchInstance = makeFetchInstance(auth, config.PUBLIC_API_URL);
  const service = new PublicApiClient(axiosInstance, fetchInstance);

  return (
    <PublicApiServiceContext.Provider value={service}>
      {children}
    </PublicApiServiceContext.Provider>
  );
};

export const usePublicApiService = () => useContext(PublicApiServiceContext);
